var _path, _path2, _path3, _path4, _path5, _path6, _circle, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-nu",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fedd00",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h320v240H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m37.5 0 122 90.5L281 0h39v31l-120 89.5 120 89V240h-40l-120-89.5L40.5 240H0v-30l119.5-89L0 32V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M212 140.5 320 220v20l-135.5-99.5zm-92 10 3 17.5-96 72H0zM320 0v1.5l-124.5 94 1-22L295 0zM0 0l119.5 88h-30L0 21z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M120.5 0v240h80V0zM0 80v80h320V80z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 96.5v48h320v-48zM136.5 0v240h48V0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 40.8,
    fill: "#012169"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fedd00",
    d: "m160 79.2 24 73.8-62.8-45.6h77.6L136 153M66.7 98.3l14 43.4L43.9 115h45.7l-37 26.8m200.7-43.5 14.1 43.4-36.9-26.8h45.7l-37 26.8M160 178.3l14.1 43.4-37-26.8h45.7l-37 26.8M160 18.3l14.1 43.4-37-26.8h45.7l-37 26.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNu);
export default __webpack_public_path__ + "static/media/nu.0c07557ad84180f95bf69219f927953c.svg";
export { ForwardRef as ReactComponent };